import createAsyncTransaction from '../../helpers';

export const ADD_TO_CART = createAsyncTransaction('ADD_TO_CART');

export const REMOVE_FROM_CART = createAsyncTransaction('REMOVE_FROM_CART');




// WEBPACK FOOTER //
// ./src/store/modules/cart/transactions.js